import { EntityRepository } from '@record-it-npm/synchro-client';
import { EntityName } from 'record-it-time-common/EntityName';
import {
  DateInput,
  DateUtils
} from 'record-it-utils/utils/DateUtils/DateUtils';
import { AppEntityManagerEntityTypesByEntityName } from '../AppEntityManagerEntityTypesByEntityName';
import { WorkTimeEntry } from './workTimeEntryTypes';
import { AppSynchronizationEnvironmentTypes } from '../../../AppSynchronizationEnvironmentTypes';

export class WorkTimeEntryRepository extends EntityRepository<
  AppSynchronizationEnvironmentTypes,
  EntityName.WorkTimeEntry,
  AppEntityManagerEntityTypesByEntityName
> {
  public getInDateRangeForUser({
    userId,
    start,
    end
  }: {
    userId: string;
    start: DateInput;
    end: DateInput;
  }): Array<WorkTimeEntry> {
    return this.getAll().filter((entry) => {
      if (entry.userId !== userId) {
        return false;
      }

      const startIsBeforeEnd = entry.startDate <= entry.endDate;

      return DateUtils.withCurrentTimezone().dateRangesOverlap(
        {
          start,
          end
        },
        {
          start: startIsBeforeEnd ? entry.startDate : entry.endDate,
          end: startIsBeforeEnd ? entry.endDate : entry.startDate
        }
      );
    });
  }

  public getByUserId(userId: string): Array<WorkTimeEntry> {
    return this.getAll().filter((entry) => entry.userId === userId);
  }
}
